export interface Clock {
  now(): Date;
  timeZone(): string;
}

export class SystemClock implements Clock {
  now(): Date {
    return new Date();
  }
  timeZone(): string {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
}

export class FixedClock implements Clock {
  constructor(
    private readonly date: Date,
    private readonly zone: string = "UTC",
  ) {}
  now(): Date {
    return new Date(this.date.getTime());
  }
  timeZone(): string {
    return this.zone;
  }
}
